import React, { Fragment } from 'react';
import { TextField } from 'components/form/Formik/index';
import RichTextEditor from 'components/form/Formik/RichTextEditor';

const RichTextBlock = ({ index }) => {
  return (
    <Fragment>
      <TextField name={`blocks.${index}.title`} placeholder="Optional title" />
      <br />
      <RichTextEditor
        name={`blocks.${index}.content`}
        placeholder="Enter your content here"
      />
    </Fragment>
  );
};

export default React.memo(RichTextBlock);
